// A conferência que roda entre o clique em "Cadastrar No Portal" e o envio.
//
// No BLL/BNC há um await (documentos obrigatórios) antes de o modal fechar. Até
// 05/10/2026, fechar o modal nessa janela NÃO cancelava: a conferência terminava e
// o envio ao portal saía mesmo assim, para um operador que achava ter desistido.
// Envio a portal é irreversível, então fechar passou a cancelar.

export type Aviso = (mensagem: string, tipo?: 'success' | 'error') => void;

export interface Conferencia {
  /** BLL/BNC: só eles têm a trava de documentos antes de enfileirar. */
  ehGkz: boolean;
  proposalId: number;
  /** Status dos documentos obrigatórios (`missing` = os que estão sem arquivo). */
  statusDosDocumentos: (proposalId: number) => Promise<{ missing?: string[] } | null | undefined>;
  /** O modal desta proposta ainda está aberto? Lido DEPOIS do await. */
  aindaAberto: () => boolean;
  avisar: Aviso;
}

/** `true` = pode enviar. `false` = não envia (documento faltando ou modal fechado). */
export async function conferirAntesDeEnviar(c: Conferencia): Promise<boolean> {
  if (c.ehGkz) {
    try {
      const docs = await c.statusDosDocumentos(c.proposalId);
      const faltando = docs?.missing || [];
      if (faltando.length > 0) {
        c.avisar(
          `⛔ ${faltando.length} documento(s) obrigatório(s) sem arquivo: ` +
            faltando.slice(0, 3).map((m) => `"${m}"`).join(', ') +
            (faltando.length > 3 ? '…' : '') +
            ' — anexe na tabela de documentos exigidos.',
          'error',
        );
        return false;
      }
    } catch { /* status indisponível → o backend valida */ }
  }
  if (!c.aindaAberto()) {
    c.avisar('Envio cancelado: o modal foi fechado antes de a conferência terminar. Nada foi enviado ao portal.');
    return false;
  }
  return true;
}
